import { FwResourceType } from '../../../model/Resource'

const all = ['tags']
const listByResource = (resource: FwResourceType) => [...all, resource]

export const tagsKeys = {
  all,
  listByResource,
}
